module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAIAAAACUFjqAAAAE0lEQVQYV2O8ecCcATdgHJXGBgD86BIrU9VnLAAAAABJRU5ErkJggg=="